if (!customElements.get('ey-lookbook-rail')) {
  customElements.define('ey-lookbook-rail', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      this.addEventListener('wheel', this.onWheel, {
        passive: false,
        signal: this.listeners.signal,
      });
      this.addEventListener('keydown', this.onKeydown, {
        signal: this.listeners.signal,
      });
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    onWheel(event) {
      if (event.ctrlKey || event.shiftKey || !event.cancelable ||
          Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;

      const maximum = this.scrollWidth - this.clientWidth;
      const step = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.clientWidth : 1;
      const delta = event.deltaY * step;
      if ((delta > 0 && this.scrollLeft >= maximum - 1) ||
          (delta < 0 && this.scrollLeft <= 1) || maximum <= 1) return;

      event.preventDefault();
      this.scrollLeft = Math.max(0, Math.min(maximum, this.scrollLeft + delta));
    }

    onKeydown(event) {
      if (event.target !== this || event.altKey || event.ctrlKey || event.metaKey) return;

      const maximum = this.scrollWidth - this.clientWidth;
      const step = this.clientWidth * 0.8;
      let destination;
      switch (event.key) {
        case 'ArrowRight': destination = this.scrollLeft + step; break;
        case 'ArrowLeft': destination = this.scrollLeft - step; break;
        case 'Home': destination = 0; break;
        case 'End': destination = maximum; break;
        default: return;
      }

      event.preventDefault();
      this.scrollTo({
        left: Math.max(0, Math.min(maximum, destination)),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }
  });
}
